<template>
    <PutForeground type="fgr"/>
</template>

<script>
import PutForeground from '@/views/put/Foreground.vue';

export default {
    components:{
        PutForeground
    },
}
</script>